import { useState } from 'react';
import { LifeBuoy, X } from 'lucide-react';
import { IconButton } from '@anyemp/ui-kit';
import { useAuth } from '../../hooks/useAuth';
import TicketsWidget from './TicketsWidget';

/**
 * Global floating support widget — available on every authenticated page.
 * Opens a panel with the user's related tickets + a button to file a new one,
 * capturing the current page as the ticket source.
 */
export default function SupportFab({ onOpenChange }) {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const setOpenState = (nextOpen) => {
    setOpen(nextOpen);
    onOpenChange?.(nextOpen);
  };

  if (!isAuthenticated) return null;

  return (
    <>
      {/* Click-away layer */}
      {open && <div className="fixed inset-0 z-30" onClick={() => setOpenState(false)} aria-hidden="true" />}

      {open && (
        <div className="fixed inset-x-0 bottom-20 z-40 w-screen animate-slide-up sm:inset-x-auto sm:bottom-24 sm:right-5 sm:w-[360px] sm:max-w-[calc(100vw-2.5rem)]">
          <TicketsWidget
            serviceName="talent-service"
            sourceLabel={`Page: ${document.title || window.location.pathname}`}
          />
        </div>
      )}

      <IconButton
        aria-label="Support tickets"
        aria-expanded={open}
        title="Support tickets"
        onClick={() => setOpenState(!open)}
        variant="filled"
        color="primary"
        size="large"
        sx="fixed bottom-5 right-5 z-40 rounded-full shadow-ui-glow transition-transform duration-ui-normal ease-ui hover:scale-105 active:scale-95"
        icon={
          <span className={`inline-flex transition-transform duration-ui-normal ease-ui ${open ? 'rotate-90' : 'rotate-0'}`}>
            {open ? <X size={22} /> : <LifeBuoy size={22} />}
          </span>
        }
      />
    </>
  );
}
